var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvalidLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.003,
    height: 28.029,
    viewBox: "0 0 28.003 28.029",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_30828",
    "data-name": "Group 30828",
    transform: "translate(-20885.459 14624.151)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22713",
    "data-name": "Path 22713",
    d: "M464.566,333.878l-2.774-.936a1.33,1.33,0,0,0-1.63.867,1.314,1.314,0,0,0,.8,1.6l2.774.936a1.256,1.256,0,0,0,1.63-.832,1.278,1.278,0,0,0-.8-1.63Z",
    transform: "translate(20446.111 -14939.538)",
    fill: "#333",
    stroke: "#e3e3e3",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22714",
    "data-name": "Path 22714",
    d: "M277.265,199.611a1.277,1.277,0,0,0-1.838,0L268.077,207a1.309,1.309,0,0,0,.069,1.838,1.325,1.325,0,0,0,1.768,0l7.351-7.385a1.342,1.342,0,0,0,0-1.838Z",
    transform: "translate(20626.58 -14814.148)",
    fill: "#333",
    stroke: "#e3e3e3",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22715",
    "data-name": "Path 22715",
    d: "M403.073,393.6a1.294,1.294,0,0,0-2.462.8l.936,2.774a1.3,1.3,0,1,0,2.462-.867Z",
    transform: "translate(20501.988 -14995.657)",
    fill: "#333",
    stroke: "#e3e3e3",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22716",
    "data-name": "Path 22716",
    d: "M238.073,84.2a1.305,1.305,0,1,0,2.5-.763c0-.035-.035-.069-.035-.1l-.936-2.774a1.311,1.311,0,0,0-1.63-.832,1.326,1.326,0,0,0-.832,1.63Z",
    transform: "translate(20655.336 -14701.999)",
    fill: "#333",
    stroke: "#e3e3e3",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22717",
    "data-name": "Path 22717",
    d: "M148.931,172.677l2.774.936a1.294,1.294,0,0,0,.8-2.462l-2.774-.9a1.256,1.256,0,0,0-1.63.832A1.273,1.273,0,0,0,148.931,172.677Z",
    transform: "translate(20738.861 -14786.902)",
    fill: "#333",
    stroke: "#e3e3e3",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22718",
    "data-name": "Path 22718",
    d: "M328.223,60.29l3.675-3.675a3.9,3.9,0,0,1,5.513,5.513L333.736,65.8A1.3,1.3,0,0,0,335.5,67.71l.069-.069,3.675-3.675a6.5,6.5,0,1,0-8.773-9.6l-4.091,4.091a1.3,1.3,0,1,0,1.768,1.907c.035,0,.035-.035.069-.069Z",
    transform: "translate(20571.947 -14676.664)",
    fill: "#333",
    stroke: "#e3e3e3",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22719",
    "data-name": "Path 22719",
    d: "M138.027,272.655l3.675-3.675a1.309,1.309,0,0,0-.069-1.838,1.325,1.325,0,0,0-1.768,0l-3.675,3.675a3.9,3.9,0,0,1-5.513-5.513l3.675-3.71a1.309,1.309,0,0,0-.069-1.838,1.325,1.325,0,0,0-1.768,0l-3.676,3.71a6.5,6.5,0,0,0,9.188,9.189Z",
    transform: "translate(20758.469 -14870.618)",
    fill: "#333",
    stroke: "#e3e3e3",
    strokeWidth: 0.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvalidLink);
export default __webpack_public_path__ + "static/media/invalid-link.57cd16fe.svg";
export { ForwardRef as ReactComponent };